module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"gis-draw-by-coordinates-form\">\n    <div>\n        <label>Проекция\n            <select name=\"projection\" on-change=\"onCoordinatesProjectionSelect\">\n                ")
    ;  _.each(projections, function(projection) { 
    ; __append("\n                <option value=\"")
    ; __append(escapeFn( projection ))
    ; __append("\" ")
    ; __append(escapeFn( projection === coordinatesProjection ? 'selected' : '' ))
    ; __append(">")
    ; __append(escapeFn( projection ))
    ; __append("</option>\n                ")
    ;  }) 
    ; __append("\n            </select>\n        </label>\n        <br/>\n        <br/>\n        <label name=\"coordinates-format-holder\">\n            Формат координат\n            <select name=\"coordinates-format\" on-change=\"onCoordinatesFormatChange\">\n                <option value=\"dd\" selected>Десятичные градусы</option>\n                <option value=\"dms\">Градусы, минуты, секунды</option>\n            </select>\n        </label>\n        <br/>\n        <br/>\n        <span>Гоеметрия: <span class=\"title\" name=\"geometry-type\">")
    ; __append(escapeFn( coordinatesGeometry ))
    ; __append("</span></span>\n    </div>\n    <div class=\"coordinates-container\">\n        <table class=\"coordinates\">\n            <thead>\n            <tr>\n                <td class=\"title\">Долгота (Longitude, X)</td>\n                <td class=\"title\">Широта (Latitude, Y)</td>\n            </tr>\n            </thead>\n            <tbody name=\"points\"></tbody>\n        </table>\n    </div>\n    <button on-click=\"onCoordinatesReadyClick\">Готово</button>\n</div>")
  }
  return __output.join("");

}